import windowObj from '../windowObj';

function insertScript(path) {
  return new Promise((resolve) => {
    const scriptTag = windowObj.document.createElement('script');
    scriptTag.onload = resolve;
    scriptTag.src = path;

    windowObj.document.head.appendChild(scriptTag);
  });
}

// iOS 9-10 does not handle spread operator on NodeList and we can't use Array.from because of IE...
function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList);
}

function getTextNodes(domContainer, exclusionFilter = () => true) {
  return nodeListToArray(domContainer.childNodes)
    .filter(exclusionFilter)
    .reduce((textNodes, child) => {
      if (child.hasChildNodes()) {
        return [...textNodes, ...getTextNodes(child, exclusionFilter)];
      }

      if (child.nodeType === windowObj.Node.TEXT_NODE && child.nodeValue.trim().length) {
        textNodes.push(child);
      }

      return textNodes;
    }, []);
}

export default {
  insertScript,
  getTextNodes,
  nodeListToArray,
};
